import { AddOn_EntityFilter, AddOn_Label, AddOn_SearchTerms } from '@nu-art/search';
export const QuaiBaseAddOns = [AddOn_EntityFilter, AddOn_Label, AddOn_SearchTerms];
export const QuaiBaseAddOnKeys = [
    AddOn_EntityFilter.key,
    AddOn_Label.key,
    AddOn_SearchTerms.key,
];
//# sourceMappingURL=base.js.map